/**
 * INFINITY LIFE 2.0 — Push Notifications & Notification Permission Manager
 */

import { api, showToast } from './api.js';
import { store } from './state.js';

export async function requestNotificationPermission() {
  if (!('Notification' in window)) {
    showToast('Este navegador não suporta notificações de sistema.', 'error');
    return false;
  }

  if (Notification.permission === 'granted') {
    showToast('Notificações já estão ativadas para este dispositivo.', 'info');
    await registerPushSubscription();
    return true;
  }

  if (Notification.permission === 'denied') {
    showToast('As notificações foram bloqueadas no navegador. Altere nas configurações do site.', 'error');
    return false;
  }

  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      showToast('Notificações ativadas com sucesso!', 'success');
      await registerPushSubscription();
      // Send real test notification
      await api.sendTestNotification();
      return true;
    } else {
      showToast('Permissão de notificação recusada.', 'info');
      return false;
    }
  } catch (err) {
    console.error('Erro ao solicitar permissão de notificação:', err);
    return false;
  }
}

export async function registerPushSubscription() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return null;
  }

  try {
    const reg = await navigator.serviceWorker.ready;
    let subscription = await reg.pushManager.getSubscription();

    if (!subscription) {
      // Create local fallback subscription or register with backend
      // VAPID keys can be provided by backend or browser
      console.log('Push manager ready on service worker.');
    } else {
      const rawKey = subscription.getKey ? subscription.getKey('p256dh') : null;
      const rawAuth = subscription.getKey ? subscription.getKey('auth') : null;

      if (rawKey && rawAuth) {
        const p256dh = btoa(String.fromCharCode.apply(null, new Uint8Array(rawKey)));
        const auth = btoa(String.fromCharCode.apply(null, new Uint8Array(rawAuth)));

        await api.subscribePush({
          endpoint: subscription.endpoint,
          keys: { p256dh, auth },
        });
      }
    }
  } catch (err) {
    console.warn('Registro de Push API indisponível ou em modo local:', err);
  }
}

export function startNotificationPoller() {
  const poll = async () => {
    if (!navigator.onLine) return;
    const { user } = store.get();
    if (!user) return;

    try {
      const res = await api.getNotifications();
      if (res.success) {
        store.set({
          notifications: res.data || [],
          unreadNotificationsCount: res.unread_count || 0,
        });
      }
    } catch (e) {
      // Quiet fail on network hiccup
    }
  };

  // Run immediately and every 60 seconds
  poll();
  return setInterval(poll, 60000);
}

export function listenNotificationMessages() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      const data = event.data;
      if (data && data.type === 'PUSH_NOTIFICATION_RECEIVED') {
        showToast(data.title || 'Nova notificação recebida', 'info');
        window.dispatchEvent(new CustomEvent('infinity:refresh-notifications'));
      }
    });
  }
}

